import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withDefaultStyles } from '@bingads-webui-react/with-default-styles';

import { TimeRangesView } from './time-ranges-view';
import { getDayName } from './time-utils';

const getStyles = (_, { palette = {} }) => ({
  header: {
    color: palette.secondaryText,
    textAlign: 'center',
    fontSize: 24,
    lineHeight: '32px',
    marginBottom: 18,
    fontWeight: 600,
  },
  grid: {
    display: 'inline-grid',
    gridTemplateColumns: '1fr 1.2fr',
    gridGap: '0px 12px',
    fontSize: 16,
    lineHeight: '20px',
  },
  gridRow: {},
  gridHeader: {
    fontWeight: 'bold',
    textAlign: 'right',
  },
  gridCell: {
    color: palette.secondaryText,
  },
});

const UnStyledSmartBusinessHoursView = ({
  id,
  hours,
  i18n,
  classes,
  hideTitle,
}) => {
  const rows = hours.map(({ day, timeSlots }) => (
    <React.Fragment key={day}>
      <div className={classNames('grid-column-day', classes.gridCell, classes.gridHeader)}>
        {getDayName(day, i18n)}
      </div>
      <div data-name={day} className={classNames('grid-column-time', classes.gridCell)}>
        <TimeRangesView
          timeSlots={timeSlots}
          i18n={i18n}
        />
      </div>
    </React.Fragment>
  ));

  return (
    <div className="business-hours" data-id={id}>
      {
        !hideTitle &&
          <div className={classNames('business-hours-header', classes.header)}>
            {i18n.getString(_TL_('Business hours'))}
          </div>
      }
      <div className={classNames('grid-column-time', classes.grid)}>
        {rows}
      </div>
    </div>
  );
};

UnStyledSmartBusinessHoursView.propTypes = {
  id: PropTypes.string.isRequired,
  hours: PropTypes.arrayOf(PropTypes.shape({
    day: PropTypes.string.isRequired,
    timeSlots: PropTypes.arrayOf(PropTypes.object),
  })).isRequired,
  i18n: PropTypes.shape({
    getString: PropTypes.func,
  }).isRequired,
  classes: PropTypes.shape({
    actionButton: PropTypes.string,
  }).isRequired,
  hideTitle: PropTypes.bool,
};

UnStyledSmartBusinessHoursView.defaultProps = {
  hideTitle: false,
};

export const SmartBusinessHoursView = withDefaultStyles(
  UnStyledSmartBusinessHoursView,
  getStyles
);
